<template lang="pug">
	.tiptap-video
		.frame
			iframe(
				:src="src",
				:title="title",
				loading="lazy",
				allowfullscreen,
				referrerpolicy="strict-origin-when-cross-origin",
				allow="autoplay; encrypted-media; picture-in-picture; fullscreen",
				sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation"
			)
</template>

<script>
export default {
	name: 'component-tiptap-video',
	props: {
		src: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			default: 'Vídeo',
		},
	},
}
</script>

<style lang="stylus" scoped src="./Video.styl"></style>
